import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface BreadCrumbItem {
    label: string;
    path?: string;
}

interface BreadCrumbProps {
    items: BreadCrumbItem[];
}

const BreadCrumb = ({ items }: BreadCrumbProps) => {
    const lastIndex = items.length - 1;
    const backLink = items[lastIndex - 1]?.path || "/";
    return (
        <Row>
            <Col xs={12}>
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    {/*<h4 className="mb-sm-0">{items[lastIndex].label}</h4>*/}
                    <div className="d-flex align-items-center gap-2">
                        {items.length > 1 && (
                            <Link to={backLink}>
                                <ArrowBackIcon style={{ fontSize: 22, cursor: "pointer", color: "#333" }} />
                            </Link>
                        )}
                        <h4 className="mb-sm-0">{items[lastIndex].label}</h4>
                    </div>

                    <div className="page-title-right">
                        <ol className="breadcrumb m-0">
                            {items.map((item:any, index:number) => (
                                <li
                                    key={index}
                                    className={`breadcrumb-item ${index === lastIndex ? "active" : ""}`}
                                >
                                    {index === lastIndex || !item.path ? (
                                        item.label
                                    ) : (
                                        <Link to={item.path}>{item.label}</Link>
                                    )}
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default BreadCrumb;